import { Button, Grid, Typography } from '@mui/material'
import { DesktopDatePicker } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import FormikTextField from 'core/components/FormikTextField'
import { dateFormat } from 'core/constants/enum'
import { timestampToYMDFormat } from 'features/dashboard/utils/dashboard'
import { reportSchema } from 'features/reports/schema'
import { Form, Formik } from 'formik'
import moment from 'moment'
import React, { useState } from 'react'
import { useAppSelector } from 'store/hooks'

type ComponentProps = {
  onApply: (fromDate: number, toDate: number) => void
  // eslint-disable-next-line react/require-default-props
  loading?: boolean
}

const LocationReportFilter: React.FC<ComponentProps> = ({
  onApply,
  loading,
}) => {
  const { serverDate } = useAppSelector(state => state.app)
  const [startDate, setStartDate] = useState(timestampToYMDFormat(serverDate))
  const [endDate, setEndDate] = useState(timestampToYMDFormat(serverDate))

  const handleSubmit = (values: { startDate: string; endDate: string }) => {
    onApply(
      moment(values.startDate).startOf('day').valueOf(),
      moment(values.endDate).endOf('day').valueOf(),
    )
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{
        startDate,
        endDate,
      }}
      validationSchema={reportSchema}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography mb={1} mt={2} variant="h6">
                Location Report
              </Typography>
              <Typography mb={2} variant="body2">
                Filter by date range to view employee office and remote working
                data
              </Typography>
            </Grid>
            <Grid item md={6} xs={12}>
              <Typography
                color="secondary"
                fontWeight={'regular'}
                sx={{ ml: 1 }}
                variant="caption"
              >
                Start Date
              </Typography>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  disableFuture={true}
                  renderInput={params => (
                    <FormikTextField
                      name="startDate"
                      readonly={true}
                      {...params}
                    />
                  )}
                  value={values.startDate}
                  onChange={newVal => {
                    setFieldValue('startDate', newVal)
                    setStartDate(moment(newVal).format(dateFormat))
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item md={6} xs={12}>
              <Typography
                color="secondary"
                fontWeight={'regular'}
                sx={{ ml: 1 }}
                variant="caption"
              >
                End Date
              </Typography>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  disableFuture={true}
                  renderInput={params => (
                    <FormikTextField
                      name="endDate"
                      readonly={true}
                      {...params}
                    />
                  )}
                  value={values.endDate}
                  onChange={newVal => {
                    setFieldValue('endDate', newVal)
                    setEndDate(moment(newVal).format(dateFormat))
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid
              item
              display="flex"
              justifyContent="flex-end"
              mb={3.5}
              mt={2}
              xs={12}
            >
              <Button disabled={loading} type="submit" variant="contained">
                Generate Location Report
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default LocationReportFilter
